import { render } from "./CloserController.vue?vue&type=template&id=cdaac8d0&scoped=true&ts=true"
import script from "./CloserController.vue?vue&type=script&lang=ts"
export * from "./CloserController.vue?vue&type=script&lang=ts"

import "./CloserController.vue?vue&type=style&index=0&id=cdaac8d0&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdaac8d0"]])

export default __exports__